import React from "react";
// import cx from "classnames";
import { Switch, Route /*, Redirect */ } from "react-router-dom";
// creates a beautiful scrollbar
// import CustomInput from "components/CustomInput/CustomInput.js";
import Alert from "container/Alert.js";
import HeaderContainer from "container/HeaderContainer.js";
import FooterDownloadContainer from "container/FooterDownloadContainer.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };
  const getRoutes = routes => {
    return routes.map((prop, key) => {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      );
    });
  };

  return (
    <>
      <HeaderContainer />
      {getRoute() ? (
        // <div className={classes.content}>
        <div>
          <Switch>{getRoutes(routes)}</Switch>
        </div>
      ) : (
        // </div>
        <div className={classes.map}>
          <Switch>{getRoutes(routes)}</Switch>
        </div>
      )}
      <Alert />
    </>
  );
}
